'use strict';

module.exports = angular.module('ngIndeterminate', []).directive('indeterminate', ["$parse", function ($parse) {
    'ngInject';

    return {
        restrict: 'AE',
        link: function link(scope, elem, attrs) {
            var indeterminateClickBehavior = attrs.indeterminateClickBehavior || 'select';
            var propKey = attrs.indeterminateKey || 'enabled';
            var disabledKey = attrs.indeterminateDisabled || 'adminDisabled';
            var trueValue = true;
            var falseValue = false;
            if (attrs.ngTrueValue && attrs.ngFalseValue) {
                trueValue = $parse(attrs.ngTrueValue)(scope);
                falseValue = $parse(attrs.ngFalseValue)(scope);
            } else if (attrs.ngTrueValue || attrs.ngFalseValue) {
                throw new Error('Must have both ngTrueValue and ngFalseValue set');
            }

            // Watch for changes to the list that comprises the indeterminate checkbox
            scope.$watch(function () {
                var values = scope.$eval(attrs.indeterminate);
                return values.filter(function (v) {
                    return !v[disabledKey];
                }).filter(function (v) {
                    return v[propKey] === trueValue;
                }).length + values.length;
            }, function () {
                var values = scope.$eval(attrs.indeterminate).filter(function (v) {
                    return !v[disabledKey];
                });
                var enabled = values.filter(function (v) {
                    return v[propKey] === trueValue;
                });
                elem[0].indeterminate = 0 < enabled.length && enabled.length < values.length;
                if (enabled.length === values.length) {
                    elem[0].checked = true;
                } else {
                    elem[0].checked = false;
                }
            });

            // Update the list when the indeterminate is clicked
            elem.on('click', function (e) {
                scope.$apply(function () {
                    var values = scope.$eval(attrs.indeterminate).filter(function (v) {
                        return !v[disabledKey];
                    });
                    var enabled = values.filter(function (v) {
                        return v[propKey] === trueValue;
                    });
                    var setValue = void 0;
                    if (enabled.length == 0) {
                        setValue = trueValue;
                    } else if (enabled.length < values.length && indeterminateClickBehavior !== 'clear') {
                        setValue = trueValue;
                    } else {
                        setValue = falseValue;
                    }
                    for (var i = 0; i < values.length; i++) {
                        if (!values[i][disabledKey]) values[i][propKey] = setValue;
                    }
                });
            });
        }
    };
}]).name;


//////////////////
// WEBPACK FOOTER
// ./src/angular-indeterminate.js
// module id = 0
// module chunks = 0 1